import React, { useState, useEffect, useRef } from "react";
import "./EditDriversModal.scss";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import closeIcon from "../../../../../../Assets/images/close-icon.svg";
import editIcon from "../../../../../../Assets/images/edit-icon.svg";
import redIcon from "../../../../../../Assets/images/close-red.svg";
import calendarIcon from "../../../../../../Assets/images/calender.svg";
import downloadiconGrey from "../../../../../../Assets/images/downloadicon-normal.png";
import downloadiconGreen from "../../../../../../Assets/images/downloadicon-active.png";

import ClipLoader from "react-spinners/ClipLoader";
import Loader from "../../../../../../Context/Loader/Loader";

import { isValidCanadianPhone } from "../../../../../../Utils/Validations/validatePhone";
import PasswordTooltip from '../../../../../../Utils/PasswordToolTip/PasswordToolTip';
import moment from "moment";
import { FIELD_MAX_LENGTHS } from "../../../Utils/Constants";
import apiClient from '../../../../../../Config/apiClient';
import { showErrorToast, showSuccessToast } from '../../../../../../Context/Toaster/Toaster';

const driversPath = process.env.REACT_APP_TC_DRIVERS_BASE_PATH;
const DATE_MONTH_FORMAT = "MM-dd-yyyy";

const EditDriverModal = ({ show, onClose, mode = "view", driverdata, defaultTab = "info", roles, refreshDriverList }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [isEditing, setIsEditing] = useState(mode === "edit");
  const [prefillLoading, setPrefillLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    newPassword: false,
    confirmPassword: false
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    contactNo: "",
    createdOn: "",
    licenseNo: "",
    licenseExpiry: "",
    documents: { license_file: null },
    existingDocs: null,
    removedDocuments: [],
    newPassword: "",
    confirmPassword: ""
  });


  const [errors, setErrors] = useState({});
  const EditfileInputRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const wrapperRef = useRef(null);

  const toggleVisibility = (field) => {
    setShowPasswords(prev => ({ ...prev, [field]: !prev[field] }));
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsFocused(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleDownloadLicense = async () => {
    if (!driverdata?.userId) return;

    try {
      setIsLoading(true);
      const response = await apiClient.get(`${driversPath}/download/${driverdata.userId}`, {
        responseType: "blob",
      });

      const fileName = driverdata.licenseFile?.split("/").pop() || `D-${formData.firstName}-${formData.lastName}-license.pdf`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      showErrorToast(err.response?.data?.message || "Failed to download license document.");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (driverdata) {
      setPrefillLoading(true);
      setFormData({
        firstName: driverdata.firstName || "",
        lastName: driverdata.lastName || "",
        email: driverdata.email || "",
        contactNo: driverdata.contactNo || "",
        role: driverdata.roleName || "",
        licenseNo: driverdata.licenseNo || "",
        licenseExpiry: driverdata.licenseExpiry || "",
        createdOn: driverdata.createdOn || "",
        documents: { license_file: null },
        existingDocs: driverdata.licenseFile ? {
          license_file: driverdata.licenseFile,
          license_file_name: driverdata.licenseFile?.split("/").pop() || "license.pdf"
        } : null,
        removedDocuments: [],
        newPassword: "",
        confirmPassword: ""
      });
      setPrefillLoading(false);
    }
  }, [driverdata]);

  useEffect(() => {
    if (show) {
      if (!isEditing) setActiveTab("info");
      setIsEditing(mode === "edit");
    }
  }, [show, mode]);

  const handleClose = () => {
    setErrors({});
    setIsEditing(mode === "edit");
    setActiveTab("info");
    onClose();
  };

  const handleCancel = () => {
    setFormData({
      firstName: driverdata.firstName || "",
      lastName: driverdata.lastName || "",
      email: driverdata.email || "",
      contactNo: driverdata.contactNo || "",
      role: driverdata.roleName || "",
      licenseNo: driverdata.licenseNo || "",
      licenseExpiry: driverdata.licenseExpiry || "",
      createdOn: driverdata.createdOn || "",
      documents: { license_file: null },
      existingDocs: driverdata.licenseFile ? {
        license_file: driverdata.licenseFile,
        license_file_name: driverdata.licenseFile?.split("/").pop() || "license.pdf"
      } : null,
      removedDocuments: [],
      newPassword: "",
      confirmPassword: ""
    });
    setErrors({});
    setIsEditing(false);
    setActiveTab("info");
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files[0]) {
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, [name]: "File size must not exceed 5 MB." }));
        e.target.value = null;
        return;
      }
      if (file.type !== "application/pdf") {
        setErrors(prev => ({ ...prev, [name]: "Only PDF files allowed" }));
        return;
      }
      setFormData(prev => ({
        ...prev,
        documents: { ...prev.documents, [name]: file },
        removedDocuments: prev.removedDocuments.filter(f => f !== name)
      }));
      setErrors(prev => ({ ...prev, [name]: "" }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  useEffect(() => {
    if (driverdata) {
      setFormData(prev => ({
        ...prev,
        documents: { license_file: null },
        removedDocuments: [],
      }));
      if (EditfileInputRef.current) {
        EditfileInputRef.current.value = "";
      }
    }
  }, [driverdata, show]);


  const handleRemoveFile = (field) => {
    if (driverdata?.licenseFile && !formData.documents[field]) {
      setFormData(prev => ({
        ...prev,
        removedDocuments: [...prev.removedDocuments, field]
      }));
    }

    setFormData(prev => ({
      ...prev,
      documents: { ...prev.documents, [field]: null },
      existingDocs: null
    }));

    setErrors(prev => ({ ...prev, [field]: "" }));

    if (EditfileInputRef.current) EditfileInputRef.current.value = "";
  };

  const validateFields = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required.";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!formData.contactNo.trim()) newErrors.contactNo = "Contact number is required.";
    else if (!isValidCanadianPhone(formData.contactNo)) newErrors.contactNo = "Invalid contact number.";
    if (!isTruckAdmin && !formData.role) newErrors.role = "Role is required.";
    if (!formData.licenseNo.trim()) newErrors.licenseNo = "License number is required.";
    if (!formData.licenseExpiry) newErrors.licenseExpiry = "License expiry is required.";
    if (!formData.documents.license_file && !formData.existingDocs?.license_file) {
      newErrors.license_file = "License Document is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePassword = () => {
    const newErrors = {};
    if (!formData.newPassword) newErrors.newPassword = "New password is required.";
    if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm password is required.";
    if (formData.newPassword && formData.confirmPassword && formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const userId = driverdata.userId
  const isTruckAdmin = driverdata?.user_role === "Truck-Admin";

  const handleSave = async () => {
    if (!validateFields()) return;

    try {
      setIsLoading(true);
      const payload = new FormData();
      payload.append("first_name", formData.firstName);
      payload.append("last_name", formData.lastName);
      payload.append("contact_no", formData.contactNo);
      if (!isTruckAdmin) { payload.append("role_id", roles.find(r => r.role_name === formData.role)?.id); }
      payload.append("license_no", formData.licenseNo);
      payload.append("license_expiry", formData.licenseExpiry);

      if (formData.documents.license_file) {
        payload.append("license_file", formData.documents.license_file);
      }

      if (formData.removedDocuments.length > 0) {
        payload.append("removed_documents", JSON.stringify(formData.removedDocuments));
      }

      await apiClient.put(`${driversPath}/update/${userId}`, payload, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      showSuccessToast("Driver updated successfully.");
      setIsEditing(false);
      refreshDriverList?.();
      window.dispatchEvent(new CustomEvent('adminProfileUpdated'));
    } catch (err) {
      showErrorToast(err.response?.data?.message || "Failed to update driver.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordChange = async () => {
    if (!validatePassword()) return;

    try {
      setIsLoading(true);
      await apiClient.put(`${driversPath}/change-password`, {
        user_id: driverdata.userId,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword
      });

      showSuccessToast("Password changed successfully.");
      setFormData(prev => ({ ...prev, newPassword: "", confirmPassword: "" }));
      setIsEditing(false);
      setActiveTab("info");
    } catch (err) {
      showErrorToast(err.response?.data?.error_data?.message || "Failed to change password.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isEditing) {
      setFormData((prev) => ({
        ...prev,
        documents: { license_file: null },
        removedDocuments: [],
      }));
      if (EditfileInputRef?.current) {
        EditfileInputRef.current.value = "";
      }
    }
  }, [isEditing]);


  let userRole = localStorage.getItem("userRole");
  try {
    userRole = JSON.parse(userRole);
  } catch {

  }
  const isUser = userRole?.trim().toLowerCase() === "truck-user";
  console.log(userRole)

  if (!show) return null;

  return (
    <div className="modal right rtm-modal editdriver-modal fade show" style={{ display: "block" }}>
      <div className="modal-dialog rtl-dialog">
        <div className="modal-content rtl-content animate__animated animate__fadeInRight" style={{ maxHeight: "100vh", overflow: "hidden" }}>
          {prefillLoading ? (
            <div style={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ClipLoader size={45} color="gray" />
            </div>
          ) : (
            <>
              <div className="ajob-content" style={{ maxHeight: "70px", overflowY: "auto" }}>
                <div className="cpf-top cpf-border">
                  <h2>Driver Details</h2>
                  {!isEditing && !isUser && (
                    <div className="driver-edit edt-icn" onClick={() => setIsEditing(true)}>
                      <img src={editIcon} alt="edit" />
                    </div>
                  )}
                  <button className="m-close" onClick={handleClose}><img src={closeIcon} alt="close" /></button>
                </div>

                <div className="modal-graybox mt-0 mg-padding" style={{ position: "relative" }}>
                  <div className="modal-profile"><h1 className="common-profile-letter">{formData.firstName?.[0]?.toUpperCase()}{formData.lastName?.[0]?.toUpperCase()}</h1></div>
                  <div className="modal-grayleft mt-0"><h2 className="graybox-title" style={{ marginTop: '31px' }}>{formData.firstName} {formData.lastName}</h2></div>
                </div>

                <div className="modal-inner">
                  <div className="drivertab-header">
                    <ul className="nav nav-tabs tab-line">
                      <li className="nav-item"><button className={`nav-link tab-btn ${activeTab === "info" ? "active" : ""}`} onClick={() => setActiveTab("info")}>Info</button></li>
                      <li className="nav-item"><button className={`nav-link tab-btn ${activeTab === "password" ? "active" : ""} ${!isEditing ? "disabled-tab" : ""}`} onClick={() => { if (isEditing) setActiveTab("password") }} disabled={!isEditing}>Password Management</button></li>
                    </ul>
                  </div>

                  <div className="drivertab-body">
                    <div className="tab-content">
                      {/* Info Tab */}
                      {activeTab === "info" && (
                        <div className="editdriver-form">
                          <div className="row">

                            {/* Email */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">Email</label>
                                <input type="text" name="email" className={`common-input`} value={formData.email} onChange={handleChange} disabled />
                              </div>
                            </div>

                            {/* Role - only show for non-admin users */}
                            {!isTruckAdmin && (
                              <div className="col-md-6">
                                <div className="cp-split">
                                  <label className="fi-label driver-lbl">Role</label>
                                  {isEditing ? (
                                    <select
                                      name="role"
                                      className={`common-select ${errors.role ? "error" : ""}`}
                                      value={formData.role}
                                      onChange={handleChange}
                                    >
                                      <option value="">--Select--</option>
                                      {roles && roles.length > 0 && roles.map((r) => (
                                        <option key={r.id} value={r.role_name}>{r.role_name}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    <input type="text" className="common-input" value={formData.role} disabled />
                                  )}
                                  <span className={`error-text ${errors.role ? "active" : ""}`}>{errors.role}</span>
                                </div>
                              </div>
                            )}


                            {/* First Name */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">First Name <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="firstName" maxLength={FIELD_MAX_LENGTHS.firstName} className={`common-input ${errors.firstName ? "error" : ""}`} value={formData.firstName} onChange={handleChange} disabled={!isEditing} />
                                <span className={`error-text ${errors.firstName ? "active" : ""}`}>{errors.firstName}</span>
                              </div>
                            </div>

                            {/* Last Name */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">Last Name <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="lastName" maxLength={FIELD_MAX_LENGTHS.lastName} className={`common-input ${errors.lastName ? "error" : ""}`} value={formData.lastName} onChange={handleChange} disabled={!isEditing} />
                                <span className={`error-text ${errors.lastName ? "active" : ""}`}>{errors.lastName}</span>
                              </div>
                            </div>

                            {/* Contact No */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">Contact No. <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="contactNo" maxLength={FIELD_MAX_LENGTHS.contact} className={`common-input ${errors.contactNo ? "error" : ""}`} value={formData.contactNo} onChange={handleChange} disabled={!isEditing} />
                                <span className={`error-text ${errors.contactNo ? "active" : ""}`}>{errors.contactNo}</span>
                              </div>
                            </div>

                            {/* Created On */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">Created On</label>
                                <input type="text" className="common-input" value={formData.createdOn ? moment(formData.createdOn).format("MM-DD-YYYY") : ""} disabled />
                              </div>
                            </div>

                            {/* License No */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">Driver License No. <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="licenseNo" className={`common-input ${errors.licenseNo ? "error" : ""}`} value={formData.licenseNo} onChange={handleChange} disabled={!isEditing} />
                                <span className={`error-text ${errors.licenseNo ? "active" : ""}`}>{errors.licenseNo}</span>
                              </div>
                            </div>

                            {/* License Expiry */}
                            <div className="col-md-6">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">License Expiry <span style={{ color: "red" }}>*</span></label>
                                <div style={{ position: 'relative' }}>
                                  <DatePicker
                                    selected={formData.licenseExpiry ? new Date(formData.licenseExpiry) : null}
                                    onChange={(date) => {
                                      setFormData((prev) => ({ ...prev, licenseExpiry: date ? date.toLocaleDateString('en-CA') : '' }));
                                      setErrors((prev) => ({ ...prev, licenseExpiry: '' }));
                                    }}
                                    placeholderText="Select date"
                                    className={`filter-date w-100 ${errors.licenseExpiry ? 'error' : ''}`}
                                    dateFormat={DATE_MONTH_FORMAT}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    minDate={new Date()}
                                    disabled={!isEditing}
                                  />
                                  <span className="filter-calendar-icon">
                                    <img src={calendarIcon} alt="calendar" />
                                  </span>
                                </div>
                                <span className={`error-text ${errors.licenseExpiry ? "active" : ""}`}>{errors.licenseExpiry}</span>
                              </div>
                            </div>

                            {/* License Document */}
                            <div className="col-md-12">
                              <div className="cp-split">
                                <label className="fi-label driver-lbl">License Document <span style={{ color: "red" }}>*</span></label>

                                {isEditing ? (
                                  <div className={`hsfile-upload ${errors.license_file ? "error-border" : ""}`}>
                                    <div className="doc-display">
                                      {formData.existingDocs?.license_file && !formData.documents.license_file ? (
                                        <label 
                                          className="file-upload-label" 
                                          onClick={handleDownloadLicense}
                                          style={{ cursor: 'pointer' }}
                                          onMouseEnter={(e) => e.target.style.color = '#28a745'}
                                          onMouseLeave={(e) => e.target.style.color = ''}
                                        >
                                          {formData.existingDocs.license_file_name}
                                        </label>
                                      ) : (
                                        <label className="file-upload-label">
                                          {formData.documents.license_file?.name || ""}
                                        </label>
                                      )}
                                      {(formData.documents.license_file || formData.existingDocs?.license_file) && (
                                        <img
                                          src={redIcon}
                                          alt="Remove"
                                          className="remove-icon"
                                          onClick={() => handleRemoveFile("license_file")}
                                        />
                                      )}
                                    </div>
                                    <label htmlFor="license_file_edit" className="browse-btn">Browse</label>
                                    <input
                                      key={formData.documents.license_file ? formData.documents.license_file.name : "empty_edit"}
                                      id="license_file_edit"
                                      name="license_file"
                                      type="file"
                                      accept=".pdf"
                                      onChange={handleChange}
                                      ref={EditfileInputRef}
                                      style={{ display: "none" }}
                                    />
                                    {errors.license_file && <span className="error-text active">{errors.license_file}</span>}
                                  </div>
                                ) : (
                                  driverdata?.licenseFile && (
                                    <div className="doc-value">
                                      <div className="doc-wraper">
                                        <div className="dlicon-cover">
                                          <img className="download-image" src={downloadiconGrey}
                                            onClick={handleDownloadLicense} alt="download" />
                                        </div>
                                        <span
                                          className="doc-name"
                                          onClick={handleDownloadLicense}
                                          style={{ cursor: 'pointer' }}
                                          onMouseEnter={(e) => e.target.style.color = '#28a745'}
                                          onMouseLeave={(e) => e.target.style.color = ''}
                                        >
                                          {driverdata.licenseFile.split("/").pop()}
                                        </span>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>

                          </div>
                          {isEditing && (
                            <div className="editdriver-buttons">
                              <button className="cancel-button me-4" onClick={handleCancel} disabled={isLoading}>Cancel</button>
                              <button className="cp-button save-btn" onClick={handleSave} disabled={isLoading}>
                                {isLoading ? <Loader size={20} /> : "Save"}
                              </button>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Password Tab */}
                      {activeTab === "password" && isEditing && (
                        <div className="editpass-form">
                          <div className="row">
                            {["newPassword", "confirmPassword"].map((name) => (
                              <div className="col-md-6" key={name}>
                                <div
                                  className="cp-split"
                                  ref={name === "newPassword" ? wrapperRef : null}
                                  style={{ position: "relative" }}
                                >
                                  <label className="fi-label driver-lbl">
                                    {name === "newPassword" ? "New Password" : "Confirm Password"}
                                  </label>
                                  <div
                                    className={`input-wraper pass-input ${name === "newPassword" && isFocused ? "focused" : ""
                                      }`}
                                    style={{ position: "relative" }}
                                  >
                                    {name === "newPassword" && isFocused && !formData.newPassword && (
                                      <PasswordTooltip />
                                    )}
                                    <input
                                      type={showPasswords[name] ? "text" : "password"}
                                      name={name}
                                      className={`common-input ${errors[name] ? "error" : ""}`}
                                      value={formData[name]}
                                      onChange={handleChange}
                                      onFocus={() => name === "newPassword" && setIsFocused(true)}
                                      maxLength={FIELD_MAX_LENGTHS.password}
                                    />
                                    <i
                                      className={`fa field-icon ${showPasswords[name] ? "fa-eye" : "fa-eye-slash"}`}
                                      onClick={() => toggleVisibility(name)}
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                  <span className={`error-text ${errors[name] ? "active" : ""}`}>
                                    {errors[name] || " "}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>

                          <div className="editpass-buttons">
                            <button
                              className="cancel-button me-4"
                              onClick={handleCancel}
                              disabled={isLoading}
                            >
                              Cancel
                            </button>
                            <button
                              className="cp-button save-btn"
                              onClick={handlePasswordChange}
                              disabled={isLoading}
                            >
                              {isLoading ? <Loader size={20} /> : "Save"}
                            </button>
                          </div>
                        </div>

                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditDriverModal;
